$(function () {
    $(window).on('load resize orientationchange', function () {
        var slider = $('.flex-split--bundle-benefits');
        if ((window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 991px)").matches) || window.matchMedia("(min-width: 1200px)").matches) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
        else {
            if (!slider.hasClass('slick-initialized')) {
                slider.slick({
                    infinite: true,
                    prevArrow: '.bundle-benefits__slide-prev',
                    nextArrow: '.bundle-benefits__slide-next',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true
                });
            }
        }
    });

    /* Drawer Content */

    (function drawers() {
        $(".bundle-content-item__list-toggle").on("click", function () {
            $(this).closest(".bundle-content-item__list-wrap").toggleClass("active");
        });
    }());
});
